import { Heading, Container, Box, Button, Link, Stack } from '@chakra-ui/react';
import { Link as GatsbyLink } from 'gatsby-plugin-react-i18next';
import { SanityCta } from '../../../graphql-types';
import useLocale from '../../lib/useLocale';
import BlockContent from '../BlockContent';
import ImageWithCropAndHotspot from '../ImageWithCropAndHotspot';

interface CTAProps {
    data: SanityCta;
}

export default function CTA({ data }: CTAProps) {
    const { translate } = useLocale();
    const title = data?.title ? translate(data?.title) : '';
    return (
        <Box
            height="50vh"
            display="grid"
            bg={data.color?.hex || 'transparent'}
            w="100%"
        >
            {data?.image?.asset?.gatsbyImageData && (
                <ImageWithCropAndHotspot
                    image={data?.image?.asset?.gatsbyImageData}
                    hotspot={data?.image?.hotspot}
                    crop={data?.image?.crop}
                    style={{
                        gridArea: '1/1',
                    }}
                    alt={title}
                />
            )}
            <Container
                size="container.lg"
                gridArea="1/1"
                maxW="5xl"
                position="relative"
            >
                <Stack
                    spacing={4}
                    textAlign="center"
                    color="white"
                    justify="center"
                    align="center"
                    h="full"
                >
                    <Heading
                        fontWeight="bold"
                        size="3xl"
                        fontSize={{
                            base: '2xl',
                            sm: '3xl',
                            md: '4xl',
                            lg: '5xl',
                        }}
                    >
                        {title}
                    </Heading>
                    {!!data.description && (
                        <Box fontSize={{ base: 'md', sm: 'lg', md: 'xl' }}>
                            <BlockContent data={data.description} />
                        </Box>
                    )}
                    {data.link && (
                        <Box>
                            <Button
                                my={2}
                                color="primary.900"
                                bg="white"
                                as={data?.link?.route ? GatsbyLink : Link}
                                to={
                                    data?.link?.route
                                        ? data?.link?.route
                                        : data.link.link
                                }
                                size="lg"
                                minW={180}
                                py={7}
                            >
                                {translate(data.link?.title || {})}
                            </Button>
                        </Box>
                    )}
                </Stack>
            </Container>
        </Box>
    );
}
